import React, { useContext, useEffect } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CrossIcon from "../../../../components/navbar/nav-icons/CrossIcon";
import "./LLMTopBar.css";
import LLMAddMenu from "./LLMAddMenu";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import MobileViewerContext from "../../../../context/studyviewer/MobileViewerContext";
import { isMobile } from "react-device-detect";

const AutoSelectedTab = ({ isChild = false }) => {
  const {
    patientReports,
    childPatientReports,
    handleChangeTemplate,
    handleChildChangeTemplate,
    activeTabKey,
    disableEditReport,
    studyReportPdf,
    studyReportPdfSelected,
    isexternalStudyReport
  } = useContext(studyReportContext);

  const { handleLlmTabRemove, isTalking } = useContext(AgenticReportingContext);
  const mobileViewerCtx = useContext(MobileViewerContext);
  const setSlideReportOpen = isMobile ? mobileViewerCtx?.setSlideReportOpen : null;

  const reports = isChild ? childPatientReports : patientReports;
  const switchHandler = isChild
    ? handleChildChangeTemplate
    : handleChangeTemplate;

  useEffect(() => {
    if (reports.length > 0) {
      const activeTabExists = reports.some((r) => r.key === activeTabKey);

      if (!activeTabExists) {
        const lastTab = reports[reports.length - 1];
        if (lastTab) {
          switchHandler(lastTab);
        }
      }
    }
  }, [reports, activeTabKey, switchHandler]);

  if (isChild && !reports.length) return null;

  return (
    <div className="llm-tab-strip">
      {isexternalStudyReport && (
            <div
          key="pdf-tab"
          className={`llm-tab ${studyReportPdfSelected ? "active" : "inactive"}`}
          onClick={() => {
            if (!isTalking) {
              handleChangeTemplate(null);
            }
          }}
          style={{
            cursor: isTalking ? "not-allowed" : "pointer",
            opacity: isTalking && !studyReportPdfSelected ? 0.6 : 1,
          }}
        >
          {(studyReportPdf?.aiPacsNodeName || "PDF") + " REPORT"}
        </div>
          )}
      {reports.map((tab, idx) => {
        const isActive = !studyReportPdfSelected && activeTabKey === tab.key;
        const displayText = tab.text;

        return (
          <div
            key={tab.key}
            className={`llm-tab ${isActive ? "active" : "inactive"}`}
            onClick={() => {
              if (!isTalking) {
                switchHandler(tab);
                if (setSlideReportOpen) setSlideReportOpen(true);
              }
            }}
            style={{
              cursor: isTalking ? "not-allowed" : "pointer",
              opacity: isTalking && !isActive ? 0.6 : 1,
            }}
          >
            {displayText}
            {!isChild && !disableEditReport && (
              <span
                className="llm-tab-close"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isTalking) {
                    handleLlmTabRemove(e, tab.key, idx);
                  }
                }}
                style={{
                  cursor: isTalking ? "not-allowed" : "pointer",
                  marginLeft: "4px",
                }}
              >
                <CrossIcon fill={true} />
              </span>
            )}
          </div>
        );
      })}
      {studyReportPdf && studyReportPdf.isAttached === true && (
        <div
          key="pdf-tab"
          className={`llm-tab ${studyReportPdfSelected ? "active" : "inactive"}`}
          onClick={() => {
            if (!isTalking) {
              handleChangeTemplate(null);
              if (setSlideReportOpen) setSlideReportOpen(true);
            }
          }}
          style={{
            cursor: isTalking ? "not-allowed" : "pointer",
            opacity: isTalking && !studyReportPdfSelected ? 0.6 : 1,
          }}
        >
          {(studyReportPdf?.aiPacsNodeName || "PDF") + " REPORT"}
        </div>
      )}
      {!isChild && !disableEditReport && <LLMAddMenu isChild={isChild} isDisabled={isTalking} />}
    </div>
  );
};

export default AutoSelectedTab;
